import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { ArticleDownloadUsage } from '@/types';
import { useQuery } from '@tanstack/react-query';

export const getArticleDownloadUsage = (): Promise<ArticleDownloadUsage> => {
  return axios.get('/api/v1/articles/download_usage');
};

type QueryFnType = typeof getArticleDownloadUsage;

type Options = {
  config?: QueryConfig<QueryFnType>;
};

export const useArticleDownloadUsage = ({ config }: Options = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['articleDownloadUsage'],
    queryFn: () => getArticleDownloadUsage(),
  });
};
